<template>
  <section class="section-pay w-full max-w-[1600px] mx-auto px-140 flex justify-between items-center min-h-400">
    <div class="section-pay-left text-left mr-100">
      <p class="text-4xl text-black mb-15 font-bold">{{ $t('lang.chooseUs1') }}</p>
      <p class="text-4xl text-black  font-bold">{{ $t('lang.chooseUs2') }}</p>
    </div>
    <div class="section-pay-right flex flex-col items-start relative right-120">
      <div class="flex items-center justify-start space-x-4 mb-10">
        <el-input v-model="email" :placeholder="$t('lang.chooseUs3')" />
        <el-button
          type="primary"
          style="background: #FF7800;border-radius: 5px 5px 5px 5px;border: 1px solid #FF7800;min-width:120px;height:35px;font-size:12px;padding: 0 20px;"
          @click="goRegister"
        >{{ $t('lang.chooseUs4') }}</el-button>
      </div>
      <!-- <div>
        <el-checkbox v-model="isAgree">
          我同意
          <span class="underline cursor-pointer">《隐私政策》</span>及相关条款。
        </el-checkbox>
      </div> -->
    </div>
  </section>
</template>

<script>
export default {
  name: "sectionPay",

  data() {
    return {
      email: '',
    };
  },

  mounted() {},

  methods: {
    goRegister() {
      window.open("https://vccmmr.geo.sh.cn/#/register?email=" + this.email);
    }
  }
};
</script>



<style lang="less">
.section-pay {
  .el-input__inner{
    background-color: #F8F8F8 !important;
    border: 1px solid #C9C9C9;
    color: #626262;
    font-size: 12px;
    height: 35px;
    border-radius: 5px 5px 5px 5px;
    // 设置 placeholder 字体大小
    &::placeholder{
      font-size: 12px;
      color: #626262;
    }
  }
}
</style>